import { render } from "./WelcomePopup.vue?vue&type=template&id=3b979eb7&scoped=true&bindings={\"visible\":\"data\",\"firstName\":\"data\",\"email\":\"data\",\"contactOptIn\":\"data\",\"canContinue\":\"options\",\"close\":\"options\",\"skip\":\"options\",\"submitLead\":\"options\"}"
import script from "./WelcomePopup.vue?vue&type=script&lang=js"
export * from "./WelcomePopup.vue?vue&type=script&lang=js"

import "./WelcomePopup.vue?vue&type=style&index=0&id=3b979eb7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3b979eb7"

export default script